import React, {useState, useRef, useEffect} from 'react'
import './Components_CSS/Songs_list.css'

function Songs_list(props) {

  const image = props.song.image[2].link;
  const song_name = props.song.name.slice(0, 20);
  const album = props.song.album.name.slice(0, 50);
  const time = props.song.duration;
  const link = props.song.downloadUrl[4].link;

  let css;
  if(link === props.current_song){
    css = {color:'#FF305C'};
  }

  return (
    <div style={css} className='song_list'>
        <div onClick={()=>props.update_cnt(props.num, song_name, album, link, image)} className='song_list_text'>
            <div className='serial_num'>
            {props.num}
            </div>

            <div className='song_list_name'>
            <img src={image}></img>
            {song_name}  
            </div>

            <div className='song_list_album'>
            {album}  
            </div>

        </div>
        <div className='song_list_time'>{`${Math.trunc(time/59)}:${time%59}`}</div>
    </div>
  )
}

export default Songs_list